import { formatMoney } from '../../lib/formatters.ts'
import type { ForecastVersion } from '../../api/cashReport'
import { equation30d } from './headlines.ts'

type Props = {
  version: ForecastVersion
  optimisticBank?: { cents: number; asOf: string } | null
  onOpenWeek: (weekStart: string | null, key?: string) => void
}

export default function EquationStrip({ version, optimisticBank = null, onOpenWeek }: Props) {
  const eq = equation30d(version, optimisticBank)
  const weeks = version.payload?.weeks || []
  const thisWeek = weeks[0]?.week_start || null
  const week30 = weeks[Math.min(3, weeks.length - 1)]?.week_start || thisWeek
  const dip = weeks.find((w) => w.below_zero || w.below_cushion)
  const dipText = dip
    ? (version.payload?.verdict?.lowest_line
      || `Cash closes below the safety cushion the week of ${dip.week_start}.`)
    : null
  const terms: { key: string; label: string; dollars: number | null; week: string | null }[] = [
    { key: 'now', label: 'Cash now', dollars: eq.cashNow, week: thisWeek },
    { key: 'in', label: 'Expected in', dollars: eq.expectedIn, week: thisWeek },
    { key: 'out', label: 'Due out', dollars: eq.dueOut, week: thisWeek },
    { key: '30', label: 'Cash in 30 days', dollars: eq.in30, week: week30 },
  ]
  return (
    <div className="cr-math" data-testid="cr-equation">
      {terms.map((t) => (
        <button
          key={t.key}
          type="button"
          className="cr-math-link"
          data-testid={`cr-equation-${t.key}`}
          onClick={() => onOpenWeek(t.week, t.key === 'now' ? 'today' : undefined)}
        >
          <span>{t.label}</span>
          <strong>{t.dollars == null ? '—' : formatMoney(t.dollars)}</strong>
        </button>
      ))}
      {dipText ? (
        <div className="cr-timing" data-testid="cr-dip-reason">
          <b>Why does it still dip?</b><br />{dipText}
        </div>
      ) : null}
    </div>
  )
}
